var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6485 15.2484C17.1799 15.7171 16.4201 15.7171 15.9515 15.2484L12 11.297L8.04853 15.2484C7.5799 15.7171 6.8201 15.7171 6.35147 15.2484C5.88284 14.7798 5.88284 14.02 6.35147 13.5514L11.1515 8.75137C11.6201 8.28274 12.3799 8.28275 12.8485 8.75137L17.6485 13.5514C18.1172 14.02 18.1172 14.7798 17.6485 15.2484Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownUp);
export default __webpack_public_path__ + "static/media/dropdown-up.12152de83b77ac627b69f07bb9ed4492.svg";
export { ForwardRef as ReactComponent };